import { humanizeSupabaseError, isSupabasePermissionError } from "@/lib/supabase-errors";

type ImportErrorLike = {
  code?: string;
  message?: string;
  details?: string;
  hint?: string;
};

export function humanizeLeadImportError(raw: unknown): string {
  const err = (raw || {}) as ImportErrorLike;
  const message = `${err.message || ""} ${err.details || ""} ${err.hint || ""}`.toLowerCase();

  if (err.code === "23505" || message.includes("duplicate key")) {
    if (message.includes("idx_leads_workspace_phone")) {
      return "Ja existe um lead com este telefone neste workspace. Ative 'Atualizar existentes por email/telefone' ou remova duplicatas do arquivo.";
    }
    if (message.includes("idx_leads_unique_instagram_user_id")) {
      return "Ja existe um lead com este usuario do Instagram neste workspace.";
    }
    return "Este lead ja existe no workspace e nao pode ser duplicado.";
  }

  if (isSupabasePermissionError(raw)) {
    return "Voce nao tem permissao para importar leads neste workspace.";
  }

  if (message.includes("limite de leads atingido")) {
    return "Limite de leads do seu plano atingido. Remova leads ou atualize o plano para continuar.";
  }

  return humanizeSupabaseError(raw, {
    permissionMessage: "Voce nao tem permissao para importar leads neste workspace.",
    fallback: "Nao foi possivel importar este lead. Revise os dados e tente novamente.",
  });
}
